/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type Image, ImageSchema } from './image'
import type { RichText } from './rich-text'
import { type CTAVideo, CTAVideoSchema } from './video'

export type ContentMediaApiProps = {
  technicalName?: Maybe<string>
  contentTitle?: Maybe<string>
  contentTitleType?: Maybe<'title1' | 'title2' | 'punchline'>
  contentText: RichText
  textPosition: 'left' | 'right'
  backgroundColor?: Maybe<'white'>
  image: Image
  ctaLink?: Maybe<CTALink>
  ctaVideo?: Maybe<CTAVideo>
  surtitle?: Maybe<string>
}

export const ContentMediaApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  contentTitle: z.nullish(z.string()),
  contentTitleType: z.nullish(z.enum(['title1', 'title2', 'punchline'])),
  contentText: LooseRichTextSchema,
  textPosition: z.enum(['left', 'right']),
  backgroundColor: z.nullish(z.enum(['white'])),
  image: ImageSchema,
  ctaLink: z.nullish(CTALinkSchema),
  ctaVideo: z.nullish(CTAVideoSchema),
  surtitle: z.nullish(z.string()),
})

/* Schemas validation */
type TestContentMediaApiProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<ContentMediaApiProps>,
    z.infer<typeof ContentMediaApiPropsSchema>
  >
>
